<div *ngIf="!isEditing" class="thought-long-text-display" [innerHTML]="field.value"></div>
<ckeditor
    *ngIf="isEditing"
    [editor]="Editor"
    [data]="field.value"
    (blur)="updateRichTextField($event)"></ckeditor>